import * as yup from 'yup';

import { isPasswordValid } from '@identity/domain/value-objects';

/** The data of the password form. It has one field, because the email cannot be edited here. */
export type PasswordFormValues = {
  password: string;
};

/** i18n keys that the resolver writes in `errors.password.message` and the component translates. */
export const PASSWORD_VALIDATION_KEYS = {
  required: 'validation.password.required',
  policy: 'validation.password.policy',
} as const;

/**
 * Validation schema of the password step. It reuses the policy of the value object instead of its
 * own regular expression, so the checklist on every keystroke and this schema on blur cannot
 * disagree.
 */
export const createPasswordFormSchema = () =>
  yup.object({
    password: yup
      .string()
      .required(PASSWORD_VALIDATION_KEYS.required)
      .test('password-policy', PASSWORD_VALIDATION_KEYS.policy, (value) => isPasswordValid(value ?? '')),
  });
